/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isFunction } from 'lodash';

// Components
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import MetadataFields from 'shared/ui/components/metadata/MetadataFields.vue';
import TypeRepresentations from 'ui/components/metadata/TypeRepresentations.vue';

const __vue_script__ = {
    name: 'MetadataEditor',

    components: {
        BaseSelect,
        MetadataFields,
        TypeRepresentations,
    },

    props: {
        params: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            event: this.params.event,
            metadata: {},
            selectedType: {},
            typeList: [],
            kbLink: this.$const.KB_LINK_METADATA_EDITOR,
        };
    },

    computed: {
        type() {
            return this.selectedType ? this.metadata[this.selectedType.id] : undefined;
        },

        typeTitle() {
            const label = this.selectedType?.label;
            return label ? label + ' ' + this.$t('metadata_editor.metadata') : '';
        },

        startOpen() {
            return !this.$services.user.isSuperAdmin() && this.type?._hide_metadata_fields;
        }
    },

    async created() {
        const routeType = (this.$router.getRouteParams() || {}).type || 'person';
        this.metadata = await this.$services.metadata.getMetadata(this.params.event._id, 0).catch(() => {
            this.$notify({
                group: 'flashes',
                type: 'error',
                text: this.$i18n.$t('metadata_editor.errors.fetch_fail')
            });
        });

        if (this.metadata) {
            this.typeList = this.$utils.metadata.getMetadataTypeList(this.metadata, { hideForMetadata: true });
            const pickerList = this.$utils.metadata.getMetadataTypeList(this.metadata, { hideForPicker: true });
            this.$store.commit('setMetadataTypeList', pickerList);
            this.selectedType = this.typeList.find(type => type.id === routeType);
        }

        this.$store.commit('setMetadataEventDoc', this.params.event);
        this.$store.commit(
            'setMetadataSettings',
            await this.$services.settings.getSettings(this.params.event._id),
        );

    },

    mounted() {
        if (isFunction(window.BSTG.hotkeys?.bind)) {
            window.BSTG.hotkeys.bind('cmd + j, ctrl + j', this.openMetadataDocument.bind(this, false), 'Opens the metadata doc in the document editor');
            window.BSTG.hotkeys.bind('cmd + shift + j, ctrl + shift + j', this.openMetadataDocument.bind(this, true), 'Opens the metadata doc in a new window in the document editor');
        }
    },

    beforeDestroy() {
        if (isFunction(window.BSTG.hotkeys?.unbind)) {
            window.BSTG.hotkeys.unbind('cmd + j, ctrl + j');
            window.BSTG.hotkeys.unbind('cmd + shift + j, ctrl + shift + j');
        }
    },

    methods: {
        onTypeSelect() {
            const path = this.$services.metadata.buildUrl(this.$const.METADATA_TYPED_ROUTE, { eventId: this.event._id, type: this.selectedType.id });
            this.$router.push(path);
        },

        /**
         * Handler for opening a document in the document editor
         *
         * @param {boolean} newWindow open in new window
         */
        openMetadataDocument(newWindow) {
            const docEditor = this.$services.blueprint.getModuleByName('document-editor');
            const path = this.$utils.modules.getRouteHref(docEditor, 'document-editor', { eventId: this.event._id, document: 'metadata' });

            if (newWindow) {
                console.info('[MetadataEditor] Opening in a new window');
                this.$services.router.openNewWindow(`${path}?document=metadata`);
            } else {
                console.info('[MetadataEditor] Opening event document in the document editor');
                this.$router.push(path, { eventId: this.event._id }, { document: 'metadata' });
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metadata-editor"},[_c('h2',[_vm._v(_vm._s(_vm.$t('metadata_editor.titles.page')))]),_c('div',{staticClass:"alert alert-warning"},[_c('span',[_vm._v(_vm._s(_vm.$t('metadata_editor.general_warning.line_1')))]),_c('br'),_c('span',[_vm._v(_vm._s(_vm.$t('metadata_editor.general_warning.line_2'))),_c('a',{attrs:{"href":_vm.kbLink}},[_vm._v(_vm._s(_vm.$t('metadata_editor.general_warning.knowledge_base')))])])]),_c('base-select',{ref:"selectedType",staticClass:"type-selection",attrs:{"name":"selectedType","options":_vm.typeList,"options-label":"label","allow-blank":false},on:{"input":_vm.onTypeSelect},model:{value:(_vm.selectedType),callback:function ($$v) {_vm.selectedType=$$v},expression:"selectedType"}}),(_vm.type)?[_c('h3',[_vm._v(_vm._s(_vm.typeTitle))]),_c('type-representations',{attrs:{"type":_vm.type,"start-open":_vm.startOpen}}),_c('metadata-fields',{attrs:{"event":_vm.event,"type":_vm.type,"fp-type":_vm.selectedType.id}})]:_vm._e()],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MetadataEditor.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__